// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__-B_mb","imageUploader":"EGiftCard_imageUploader__2K4tl"};